import { Role } from "./models/Involved";
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Farm } from "./models/Farm";
import { CampaignObj } from "./models/Campaign";
import { Council } from "./models/Council";
import { Province } from "./models/Province";

export default class FarmerRegistryVuexModule extends AbacoVuexModule {
    @State() farm!: Farm | null;
    @State() farmNavBarFilterOpen!: boolean;
    @State() currentCampaign!: number | null;
    @State() campaignObj!: CampaignObj | null;
    @State() campaignNavBarFilterOpen!: boolean;
    @State() triggerCampaignReload!: number;
    @State() hasSCLeaderFilter!: boolean;
    @State() SCLeader!: Farm | null;
    @State() SCLeaderNavBarOpen!: boolean;
    @State() curRole!: Role | null;
    @State({ default: 0 }) triggerUpdateRoles!: number;
    @State() autoSelectableFarm!: Farm | null;
    @State() autoSelectFarm!: boolean;
    @State() canViewWorker!: boolean;
    @State() canEditWorker!: boolean;
    @State() canViewOrganization!: boolean;
    @State() canEditOrganization!: boolean;
    @State() canViewSupplyChain!: boolean;
    @State() canEditSupplyChain!: boolean;
    @State() canViewAdministrativeRole!: boolean;
    @State() canEditAdministrativeRole!: boolean;
    @State() canViewDossier!: boolean;
    @State() canImportRegistry!: boolean;
    @State() canImportRegistryBySubject!: boolean;
    @State({ default: 0 }) refreshFarmFilter!: number;
    @State({ default: 0 }) refreshInvoledLaborList!: number;
    @State() council!: Council | null;
    @State() province!: Province | null;
    @State() canManageDocuments!: boolean | null;
    @State({ default: null }) curDocumentPosition!: {
        id: string;
        description: string;
        value: (number | null)[];
    } | null;
    @State({ default: false }) curDocumentOpened!: boolean;
    @State({ default: false }) curDocumentPositionInEdit!: boolean;
    @State({ default: 0 }) updateDocumentFormPositionFromMap!: number;
    @State({ default: 0 }) updateDocumentMapPositionFromForm!: number;
}
